import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { URLS } from '@/constants/api';
import { apiSelfCareFetcher } from '../fetcher';
import { HTTPMethod } from '@/constants/rest';
import { operations } from '@/api/skippay/generated/selfCare';
import { getCountryCode } from '@/constants/country';

export type MutationBodyCreate =
	operations['customerRequestCreate']['requestBody']['content']['application/json'];
type MutationResponseCreate =
	| operations['customerRequestCreate']['responses']['200']['content']['application/json']
	| undefined;

type MutateFunctionType = (data: MutationBodyCreate) => Promise<MutationResponseCreate>;

export function useCustomerRequestCreateQuery(): UseMutationResult<
	MutationResponseCreate,
	unknown,
	MutationBodyCreate,
	unknown
> {
	const language = process.env.NEXT_PUBLIC_LANGUAGE;

	const mutationFunction: MutateFunctionType = async (data: MutationBodyCreate) => {
		const res = await apiSelfCareFetcher<Promise<MutationResponseCreate>>(
			URLS.customerDataRequestCreate,
			{
				method: HTTPMethod.POST,
				body: {
					...data,
					country: getCountryCode(language),
				},
			}
		);
		return res.json;
	};

	return useMutation({
		mutationFn: mutationFunction,
	});
}
